// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"b99b642b","551":"33b7b1ac","640":"6a9153e2"}[chunkId] + ".chunk.js";
};